var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 102,
    viewBox: "0 0 80 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9549 85.4551H40.0752V100.384H41.9549V85.4551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 85.4551V100.384H15.9797V98.5141H2.37972V87.3251H15.9797V85.4551H0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.521 85.4551V100.384H60.0007V98.5141H46.4007V93.8546H60.0007V91.9846H46.4007V87.3251H60.0007V85.4551H44.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4956 85.4551H77.6159V98.5141H71.97V85.4551H70.0903V98.5141H64.4466V85.4551H62.5669V100.384H79.4979L79.4956 85.4551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0275 98.0611L19.156 85.4551H16.8613L28.0275 101.319L39.1937 85.4551H36.899L28.0275 98.0611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5334 11.8453V0.319336H0.5V11.8453H25.569V6.08343H27.4644V11.8453H52.5334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8284 40.5586H0.5V52.0846H18.8284V40.5586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0521 27.1445H20.7236V38.6705H39.0521V27.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0523 67.3838H0.5V78.9097H39.0523V67.3838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2762 40.5586H40.9478V52.0846H59.2762V40.5586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2762 27.1445H40.9478V38.6705H59.2762V27.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1716 52.0846H72.7864V53.9724H40.9478V65.4984H79.5V40.5586H61.1716V52.0846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5001 13.7334H54.4312V25.2594H79.5001V13.7334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0521 40.5586H20.7236V52.0846H39.0521V40.5586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8284 27.145H7.21362V25.2594H25.569V13.7334H0.5V38.6732H18.8284V27.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5333 13.7334H27.4644V25.2594H52.5333V13.7334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 67.3838H40.9478V78.9097H79.5V67.3838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5001 0.319336H54.4312V11.8453H79.5001V0.319336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4998 27.1445H61.1714V38.6705H79.4998V27.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0523 53.9727H0.5V65.4986H39.0523V53.9727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 101,
    fill: "white",
    transform: "translate(0.5 0.319336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCview);
export default __webpack_public_path__ + "static/media/cview.ac729630e6137a6261bc2e3b0a012aec.svg";
export { ForwardRef as ReactComponent };